
<div class="row column resultCard" [ngClass]="{'noBorderCard': resultRecIndex === 0}">
  <div style="display: flex; margin-left:-50px;">

    <div class="vf-form__item vf-form__item--checkbox">
      <input
        type="checkbox"
        name="{{ orderedUniprotAccessions.join(',') }}"
        id="{{ orderedUniprotAccessions.join(',') }}"
        value="{{ resultRec.modelEntityId }}-v{{ resultRec.latestVersion }}"
        class="vf-form__checkbox"
        [checked]="isSelected"
        [disabled]="isLimitReached && !isSelected"
        (change)="notifySelectionChange($event)">
      <label for="{{ orderedUniprotAccessions.join(',') }}" class="vf-form__label"></label>
    </div>

    <div>
      <a class="vf-link" style="display: inline-block; box-shadow: none;"
        href="/entry/{{resultRec.modelEntityId}}"
       (click)="gaService.eventEmitter(
        'search_click_through',
        'search',
        'click',
        resultRec.modelEntityId,
        undefined
        ); trackSearchResultClick()">
        @if (resultRec.isComplex) {
          <h3 style="margin-bottom: 4px;" class="resultTitle">{{resultRec.complexName ? resultRec.complexName : 'Not named'}}</h3>
        }
        @if (!resultRec.isComplex) {
          <h3 style="margin-bottom: 4px;" class="resultTitle">{{orderedUniprotDescriptions.length ? orderedUniprotDescriptions[0] : 'Not named'}}</h3>
        }
      </a>

    </div>
  </div>

  <div class="subtitleContainer hide-for-large hide-for-medium" style="display:flex; flex-direction: column; align-items: start; ">
    @if (resultRec.isComplex === true) {
      <div class="results-chip multichip"><span class="chip-title">{{ resultRec.oligomericStateDescription }}</span></div>
    }
    @if (resultRec.isComplex === false) {
      <div class="results-chip monochip"><span class="chip-title">Monomer</span></div>
    }
    <div class="resultSubtitle"> {{resultRec.modelEntityId}}-v{{resultRec.latestVersion}} </div>
    <div class="resultSubtitle" style="display:flex"> {{providerName}} dataset  <app-entry-status [isProteome]="(resultRec.isUniProtReferenceProteome)" [isReviewed]="(resultRec.isUniProtReviewed)"></app-entry-status></div>
  </div>

  <div class="subtitleContainer hide-for-small-only" style="display:flex; ">
    @if (resultRec.isComplex === true) {
      <div class="results-chip multichip"><span class="chip-title">{{ resultRec.oligomericStateDescription }}</span></div>
    }
    @if (resultRec.isComplex === false) {
      <div class="results-chip monochip"><span class="chip-title">Monomer</span></div>
    }
    <div class="dot">•</div>
    <div class="resultSubtitle"> {{resultRec.modelEntityId}} </div>
    <div class="dot">•</div>
     <div class="resultSubtitle">Version v{{ resultRec.latestVersion }}</div>
     <div class="dot">•</div>
    <div class="resultSubtitle"> {{providerName}} dataset </div>
    <app-entry-status [isProteome]="(resultRec.isUniProtReferenceProteome)" [isReviewed]="(resultRec.isUniProtReviewed)"></app-entry-status>
  </div>

  @if (resultRec.isComplex) {
    <div>
      <div class="row resultRow" style="display:flex;">
        <div class="resultLeftCol columns leftcol-container">Components</div>
        <div class="resultRightCol columns small-8 medium-10">
          @for (complex of resultRec.complexComposition; track complex; let i = $index) {
            <div>
              {{ formatComplexCompositionSentence([complex]) }}
              @if (orderedUniprotDescriptions?.[i]) {
                <span>({{ orderedUniprotDescriptions[i] }})</span>
              }
              @if (orderedUniprotAccessions?.[i]) {
                <a href="{{uniprotBaseUrl}}{{orderedUniprotAccessions[i]}}" class="vf-link ext" style="margin-left: 4px;" target="_blank">go to UniProt</a>
              }
            </div>
          }
        </div>
      </div>
      <div class="row resultRow" style="display:flex;">
        <div class="resultLeftCol columns leftcol-container">Source organism</div>
        <div class="resultRightCol columns small-8 medium-10">
          <i> {{ orderedOrganismScientificNames.join(', ') }} </i>
          @if (orderedOrganismScientificNames?.[0]) {
            <a href="./search/organismScientificName/{{commonService.escapeValue(orderedOrganismScientificNames[0])}}" class="vf-link ext" style="margin-left: 4px;" target="_blank">search this organism </a>
          }
        </div>
      </div>
    </div>
  }

  @if (!resultRec.isComplex) {
    <div>
      <div class="row resultRow" style="display:flex;">
        <div class="resultLeftCol columns leftcol-container">Protein</div>
        <div class="resultRightCol columns small-8 medium-10">
          {{ orderedUniprotDescriptions.length ? orderedUniprotDescriptions.join(', ') : 'Not named' }}
        </div>
      </div>
      <div class="row resultRow" style="display:flex;">
        <div class="resultLeftCol columns leftcol-container">Gene</div>
        <div class="resultRightCol columns small-8 medium-10">
          {{ orderedGenes.length ? orderedGenes.join(', ') : 'Not named' }}
        </div>
      </div>
      <div class="row resultRow" style="display:flex;">
        <div class="resultLeftCol columns leftcol-container">Source organism</div>
        @if (orderedOrganismScientificNames.length > 0) {
          <div class="resultRightCol columns small-8 medium-10">
            <span>
              @if (orderedOrganismScientificNames.length) {
                <i>{{ orderedOrganismScientificNames.join(', ') }}</i>
              }
              {{ orderedOrganismScientificNames.length ? '' : 'Not available' }}
            </span>
            <a class="vf-link ext" target="_blank"
              href="./search/organismScientificName/{{commonService.escapeValue(orderedOrganismScientificNames[0])}}"> search this organism
            </a>
          </div>
        }
        @if (orderedOrganismScientificNames.length === 0) {
          <div class="resultRightCol columns small-8 medium-10">
            Not available
          </div>
        }
      </div>
      <div class="row resultRow" style="display:flex;">
        <div class="resultLeftCol columns leftcol-container">UniProt</div>
        @if (resultRec.isUniProt) {
          <div class="resultRightCol columns small-8 medium-10">
            {{ orderedUniprotAccessions.length ? orderedUniprotAccessions.join(', ') : 'Data unavailable (protein not indexed in UniProt)' }}
            @if (orderedUniprotAccessions?.[0]) {
              <a target="_blank" href="http://www.uniprot.org/uniprot/{{orderedUniprotAccessions[0]}}" class="vf-link ext">go to UniProt</a>
            }
          </div>
        }
        @if (!resultRec.isUniProt) {
          <div class="resultRightCol columns small-8 medium-10">
            Data unavailable (protein not indexed in UniProt)
          </div>
        }
      </div>
    </div>
  }

  @if (!resultRec.isComplex) {
    <div class="row resultRow" style="display:flex;">
      <div class="resultLeftCol columns leftcol-container">Experimental structures</div>
      @if (resultRec.isUniProt && kbCount && kbCount > 0) {
        <div class="resultRightCol columns small-8 medium-10">{{kbCount}} PDB structure{{kbCount > 1 ? 's' : ''}}
          for {{orderedUniprotAccessions[0]}}<a target="_blank" href="https://www.ebi.ac.uk/pdbe/pdbe-kb/proteins/{{orderedUniprotAccessions[0]}}" class="vf-link ext">go to PDBe-KB</a>
        </div>
      }
      @if (resultRec.isUniProt && kbCount === 0) {
        <div class="resultRightCol columns small-8 medium-10">None available in the PDB
        </div>
      }
      @if (!resultRec.isUniProt) {
        <div class="resultRightCol columns small-8 medium-10">Not available</div>
      }
    </div>
  }

  <div class="row resultRow" style="display:flex;">
    <div class="resultLeftCol columns leftcol-container">Global quality </div>

    <div class="metric-parent">
      @if (resultRec.globalMetricValue) {
        <div class="resultRightCol columns metric-in">
          <span class="matrix-sp">average pLDDT</span>  {{resultRec.globalMetricValue}} ({{ getPlddtLevel(resultRec.globalMetricValue) }})
        </div>
      }
    </div>

    @if (!resultRec.globalMetricValue) {
      <div class="resultRightCol columns small-8 medium-10">
        Not available
      </div>
    }
  </div>

  @if (resultRec.isComplex) {
    <div class="row resultRow" style="display:flex;">
      <div class="resultLeftCol columns leftcol-container">Interface quality </div>
      <div class="metric-parent">
        <div class="resultRightCol columns metric-in">
          <span class="matrix-sp">ipSAE</span>  {{resultRec.complexPredictionAccuracy_ipSAE}} ({{ getipSAELevel(resultRec.complexPredictionAccuracy_ipSAE) }})
        </div>
        <div class="resultRightCol columns metric-in">
          <span class="matrix-sp">ipTM</span>  {{resultRec.complexPredictionAccuracy_ipTM}}
        </div>
        <div class="resultRightCol columns metric-in">
          <span class="matrix-sp">pDockQ2 </span>  {{resultRec.complexPredictionAccuracy_pDockQ2}}
        </div>
        <div class="resultRightCol columns metric-in">
          <span class="matrix-sp">LIS </span>  {{resultRec.complexPredictionAccuracy_LIS}}
        </div>
      </div>
      @if (!resultRec.globalMetricValue) {
        <div class="resultRightCol columns small-8 medium-10">
          Not available
        </div>
      }
    </div>
  }

  @if (!resultRec.isComplex) {
    <div class="row resultRow" style="display:flex;">
      <div class="resultLeftCol columns leftcol-container">Sequence length</div>
      @if (resultRec.sequenceStart && resultRec.sequenceEnd) {
        <div class="resultRightCol columns small-8 medium-10">
          {{ (resultRec.sequenceEnd - resultRec.sequenceStart) + 1 }}
        </div>
      }
      @if (!resultRec.sequenceStart || !resultRec.sequenceEnd) {
        <div class="resultRightCol columns small-8 medium-10">
          Not available
        </div>
      }
    </div>
  }

  <!-- <div class="row resultRow" *ngIf="resultRec.complexPredictionAccuracy_ipTM">
  <div class="resultLeftCol columns small-4 medium-2">ipTM</div>
  <div class="resultRightCol columns small-8 medium-10">
    {{ resultRec.complexPredictionAccuracy_ipTM ? resultRec.complexPredictionAccuracy_ipTM : 'Not available' }}
  </div>
</div> -->

@if (isSequenceSearch  && isBrowser) {
  <app-sequence-card [isExpandStructure]="false" [hsps]="resultRec.sequenceData"></app-sequence-card>
}
</div>
